export default __webpack_public_path__ + "static/media/home-shop-classic-01.79024814.png";